import React from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from 'react-router-dom';

const TravelCard = ({
  image,
  title,
  subtitle,
  duration,
  amenities,
  highlights,
  pricePerPerson,
  totalPrice,
  priceNote,
}) => {
    const navigate = useNavigate();
  return (
    <div className="bg-white rounded-2xl shadow-md overflow-hidden flex flex-col max-w-md w-full  ">
      <div className="relative">
        <img src={image} alt={title} className="w-full h-52 object-fill" />
        <div className="absolute top-2 right-2 bg-white border border-gray-300 text-sm px-2 py-0.5 rounded-full font-semibold">
          {duration}
        </div>
      </div>

      <div className="p-4 flex flex-col gap-3">
        <div>
          <h3 className="text-lg font-bold">{title}</h3>
          <p className="text-gray-600 text-sm">{subtitle}</p>
        </div>

        <ul className="text-sm text-gray-700 grid grid-cols-2 gap-y-1">
          {amenities.map((item, index) => (
            <li key={index} className="flex items-start gap-1">
              <span className="text-lg leading-none">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>

        <div className="text-sm text-teal-700 space-y-1">
          {highlights.map((item, index) => (
            <p key={index} className="flex items-center gap-1">
              ✅ <span className="underline">{item}</span>
            </p>
          ))}
        </div>

        <div className="bg-gray-100 rounded-xl px-4 py-3 mt-2 text-sm" onClick={() => navigate('/packageDetailPage')}>
          <p className="text-gray-600">{priceNote}</p>

          <div className="mt-1 font-bold text-lg">
            ₹{pricePerPerson.toLocaleString()} <span className="text-sm font-normal">/Person</span>
          </div>
          <div className="text-gray-600 text-xs">Total Price ₹{totalPrice.toLocaleString()}  </div>
          <div className='flex justify-end'>          
            <ArrowForwardIosIcon color="primary" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelCard;
